export default "__VITE_ASSET__Dh6Iyjvw__"